import { render, staticRenderFns } from "./OrgItemClientSnapshot.vue?vue&type=template&id=0ccc192c"
import script from "./OrgItemClientSnapshot.vue?vue&type=script&lang=js"
export * from "./OrgItemClientSnapshot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports